import * as React from 'react'
import { StyledComponentClass } from 'styled-components'
import styled from '../theme/styled'
import { IdropdownAnimationProps, IDropdownDivInternalProps } from '../types/index'

const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: ${({ theme }) => `${theme.color.white}`};
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 0px;
  z-index: 1;
  transition: all 0.2s;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
    margin-left: -110px;
  }
  `

const AnimationWrapper = styled.div`
  position: relative;
  display: inline-block;
  transition: all 0.2s;
  cursor: pointer;

  &:hover  ${DropdownContent} {
    display: block;
  }
`

const normalProps = {
  color: 'white',
  fontColor: 'textDark',
}

const highlightProps = {
  color: 'primaryDark',
  fontColor: 'white',
}
const DropdownDiv: StyledComponentClass<IDropdownDivInternalProps, any> = styled<IDropdownDivInternalProps, 'div'>('div')`
  transition: all 0.2s;
  text-transform: none;
  width: 125px;
  text-align: center;
  padding: 10px 25px;
  background-color: ${({ color, theme }) => theme.color[color]};
  color: ${({ fontColor, theme }) => theme.color[fontColor]};
`

const Loader = styled.div`
display: block;
margin: auto;
border: 4px solid ${({ theme }) => `${theme.color.lightGrey}`};
border-radius: 50%;
border-top: 4px solid ${({ theme }) => `${theme.color.textLight}`};
width: 15px;
height: 15px;
-webkit-animation: spin 0.5s linear infinite; /* Safari */
animation: spin 0.5s linear infinite;
/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`

class DropdownAnimation extends React.PureComponent<IdropdownAnimationProps> {

  setSnapshot(id: number) {
    if (this.props.timer) this.props.stopTimer()
    this.props.setId(id)
  }

  renderSnapshots(snaps: { timestamp: string, snapshot: string }[]) {
    return snaps.map((snap, id) => <DropdownDiv key={id}
      {...(id === this.props.animationId ? highlightProps : normalProps)}
      onMouseOver={this.setSnapshot.bind(this, id)} >
      {snap.timestamp}
    </DropdownDiv >
    )
  }

  render() {
    return (
      <AnimationWrapper>
        <span>timeline</span>
        <DropdownContent>
          {this.renderSnapshots(this.props.snapshot[this.props.view])}
          {this.props.snapshot[this.props.view].length <= 11 ? <DropdownDiv {...normalProps}><Loader /></DropdownDiv> : ''}
        </DropdownContent>
      </AnimationWrapper>
    )
  }
}

export default DropdownAnimation



// WEBPACK FOOTER //
// ./src/components/DropdownAnimation.tsx